export function b64u(bytes: Uint8Array): string {
  let bin = ''
  for (const b of bytes) bin += String.fromCharCode(b)
  return btoa(bin).replaceAll('+', '-').replaceAll('/', '_').replace(/=+$/, '')
}

export function unb64u(text: string): Uint8Array {
  const padded = text.replaceAll('-', '+').replaceAll('_', '/')
  const bin = atob(padded + '='.repeat((4 - (padded.length % 4)) % 4))
  return Uint8Array.from(bin, (c) => c.charCodeAt(0))
}

export const utf8 = (text: string): Uint8Array => new TextEncoder().encode(text)
export const fromUtf8 = (bytes: Uint8Array): string =>
  new TextDecoder().decode(bytes)

// WebCrypto's BufferSource wants a view over a plain ArrayBuffer; TypeScript
// types a bare Uint8Array as possibly SharedArrayBuffer-backed, so copy into a
// fresh buffer before handing bytes to `subtle`.
export function bufferSource(view: Uint8Array): Uint8Array<ArrayBuffer> {
  const copy = new Uint8Array(new ArrayBuffer(view.byteLength))
  copy.set(view)
  return copy
}

export function concat(...parts: Uint8Array[]): Uint8Array {
  const out = new Uint8Array(parts.reduce((n, p) => n + p.length, 0))
  let offset = 0
  for (const p of parts) {
    out.set(p, offset)
    offset += p.length
  }
  return out
}
